import React from 'react';
const IconPersonOneFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.7001 14H5.30014L2.39014 22H17.3501L16.6201 20.01H11.3301L12.0601 18.01H18.0201L19.4801 22H21.6101L18.7001 14Z" fill="#2D2E2E"/>
<path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconPersonOneFill;